/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Zmiany obserwowanych zdrapek — Fala 4C (25.09.2026). ES5, bez bibliotek,
 * bez sieci, bez powiadomien.
 *
 * Porownuje PUBLICZNE dane organizatora z katalogu (assets/json/db/zdrapki.json,
 * bin/import-zdrapki.php) — te, ktore szablon zdrapki.html.twig wystawia w
 * atrybutach data-* kafla — z mala migawka zapisana w tej przegladarce przy
 * poprzednim odczycie. Dotyczy wylacznie zdrapek z listy obserwowanych
 * (`pewniaki.zdrapki.obserwowane.v1`, zdrapki-narzedzia.js); listy, limitow,
 * filtra i usuwania nie dotyka.
 *
 * KLUCZ `pewniaki.zdrapki.migawka.v1`: { v: 1, poz: { "<id>": { t, s, c, w, g, p, k } } }
 *   t — czas lokalnego odczytu (ms); s — status_api (Standard/Novelity/LastChance);
 *   c — cena; w — najwyzsza wygrana; g — nagrody glowne pozostale w puli
 *   (liczba z API, wg emisji); p — pula nagrod pozostala (z API); k — data
 *   konca sprzedazy. Pole bez danych = null i NIGDY nie jest zamieniane na 0.
 *   Nic wiecej: zadnych danych gracza, zadnych pol wyliczanych.
 *
 * Kontrakt:
 *   - pierwszy odczyt obserwowanej zdrapki tworzy jej wpis bazowy — bez
 *     komunikatu „zmienilo sie";
 *   - kolejne wejscie pokazuje wylacznie faktyczna roznice tych pol
 *     (stara wartosc -> nowa); brak roznic = neutralny stan;
 *   - zdrapka obserwowana, ktorej nie ma juz w katalogu, dostaje neutralny
 *     komunikat, a jej wpis zostaje (porownanie wroci, gdy wroci zdrapka);
 *   - usuniecie z obserwowanych usuwa wpis migawki od razu;
 *   - po porownaniu migawka jest nadpisywana biezacym stanem;
 *   - zly JSON, obca wersja, zablokowany storage albo niepelne dane nie psuja
 *     strony: blok zostaje ukryty albo pokazuje tylko to, co da sie opisac.
 * Czego NIE robimy: nie liczymy sprzedanych losow, nie nazywamy niczego
 * „aktualna szansa", nie wnioskujemy ze spadku liczby nagrod o sprzedazy.
 *
 * Test: node bin/test-zdrapki-zmiany.js (bez DOM), node ai/test-fala-4c-dom.js.
 */
(function (root) {
    'use strict';

    var KLUCZ_MIGAWKI = 'pewniaki.zdrapki.migawka.v1';
    var WERSJA = 1;
    var WZOR_ID = /^\d{1,9}$/;
    var WZOR_DATY = /^\d{4}-\d{2}-\d{2}$/;
    var STATUSY = [jst("ui.ef6691545d2c5523"), jst("ui.a0f51f2e5a7bad2c"), 'LastChance'];
    // Pola migawki: [klucz w migawce, atrybut data-* kafla, rodzaj].
    var POLA = [
        ['s', 'data-status', 'status'],
        ['c', 'data-cena', 'kwota'],
        ['w', 'data-wygrana', 'kwota'],
        ['g', 'data-glowne', 'liczba'],
        ['p', 'data-pula', 'kwota'],
        ['k', 'data-koniec', 'data']
    ];
    var KLUCZE_TEKSTOW = ['naglowek', 'baza', 'bez_zmian', 'niedostepna', 'nota', 'pole_s', 'pole_c', 'pole_w',
        'pole_g', 'pole_p', 'pole_k', 'brak', 'status_Standard', 'status_Novelity', 'status_LastChance', 'waluta'];

    function maWlasne(o, k) { return o !== null && typeof o === 'object' && Object.prototype.hasOwnProperty.call(o, k); }

    function normalizujId(id) {
        if (typeof id === 'number' && isFinite(id) && id >= 0 && Math.floor(id) === id) id = String(id);
        if (typeof id !== 'string' || !WZOR_ID.test(id)) return null;
        return id;
    }

    /* Wartosc pola z atrybutu/JSON: liczba calkowita >= 0 (0 to prawdziwa wartosc),
       status z listy, data RRRR-MM-DD. Wszystko inne (pusty napis, -1, ujemne,
       ulamek, nieznany status) = null, czyli brak danych. */
    function normalizujPole(rodzaj, v) {
        if (v === null || v === undefined) return null;
        if (rodzaj === 'status') return typeof v === 'string' && STATUSY.indexOf(v) >= 0 ? v : null;
        if (rodzaj === 'data') return typeof v === 'string' && WZOR_DATY.test(v) ? v : null;
        if (typeof v === 'string') { if (!/^\s*\d{1,15}\s*$/.test(v)) return null; v = Number(v); }
        if (typeof v !== 'number' || !isFinite(v) || v < 0 || Math.floor(v) !== v) return null;
        return v;
    }

    /* Stan jednej zdrapki z atrybutow kafla (obiekt z getAttribute) albo z plaskiego obiektu {status, cena, ...}. */
    function odczytajKafel(el) {
        if (!el || typeof el.getAttribute !== 'function') return null;
        var w = {};
        for (var i = 0; i < POLA.length; i++) {
            var a = el.getAttribute(POLA[i][1]);
            w[POLA[i][0]] = normalizujPole(POLA[i][2], a === '' ? null : a);
        }
        return w;
    }

    function normalizujWpis(w) {
        if (!w || typeof w !== 'object') return null;
        var out = { t: typeof w.t === 'number' && isFinite(w.t) && w.t > 0 ? Math.floor(w.t) : null };
        if (out.t === null) return null;
        for (var i = 0; i < POLA.length; i++) out[POLA[i][0]] = normalizujPole(POLA[i][2], maWlasne(w, POLA[i][0]) ? w[POLA[i][0]] : null);
        return out;
    }

    /* Migawka z tekstu localStorage: { poz: {id: wpis} }. Zly JSON / obca wersja / smieci -> pusta. */
    function wczytajMigawke(tekst) {
        var pusta = { v: WERSJA, poz: {} };
        if (typeof tekst !== 'string' || tekst === '') return pusta;
        var d;
        try { d = JSON.parse(tekst); } catch (e) { return pusta; }
        if (!d || typeof d !== 'object' || d.v !== WERSJA || !d.poz || typeof d.poz !== 'object') return pusta;
        var out = { v: WERSJA, poz: {} };
        for (var id in d.poz) {
            if (!maWlasne(d.poz, id)) continue;
            var cid = normalizujId(id), w = normalizujWpis(d.poz[id]);
            if (cid !== null && w !== null) out.poz[cid] = w;
        }
        return out;
    }

    /* Roznice pol miedzy starym wpisem a biezacym stanem: [{pole, przed, po}]. Oba null = brak roznicy. */
    function roznice(stary, nowy) {
        var out = [];
        for (var i = 0; i < POLA.length; i++) {
            var k = POLA[i][0], a = stary ? stary[k] : null, b = nowy ? nowy[k] : null;
            if (a === undefined) a = null;
            if (b === undefined) b = null;
            if (a !== b) out.push({ pole: k, przed: a, po: b });
        }
        return out;
    }

    /**
     * Porownanie i nowa migawka. obserwowane: [id]; katalog: {id: stanKafla}
     * (tylko zdrapki obecne w katalogu); migawka: wczytana; teraz: ms.
     * Zwraca { migawka (do zapisu), wynik: { nowe:[id], zmiany:[{id, roznice}],
     * bezZmian:[id], niedostepne:[id], poprzedniOdczyt: ms|null } }.
     */
    function porownaj(obserwowane, katalog, migawka, teraz) {
        var stare = migawka && migawka.poz ? migawka.poz : {};
        var nowa = { v: WERSJA, poz: {} };
        var wynik = { nowe: [], zmiany: [], bezZmian: [], niedostepne: [], poprzedniOdczyt: null };
        var lista = Array.isArray(obserwowane) ? obserwowane : [];
        for (var i = 0; i < lista.length; i++) {
            var id = normalizujId(lista[i]);
            if (id === null) continue;
            var stary = maWlasne(stare, id) ? stare[id] : null;
            var biezacy = maWlasne(katalog, id) ? katalog[id] : null;
            if (stary && (wynik.poprzedniOdczyt === null || stary.t > wynik.poprzedniOdczyt)) wynik.poprzedniOdczyt = stary.t;
            if (!biezacy) {
                // Nie ma jej w katalogu (wycofana albo chwilowo niedostepna): neutralnie, wpis zostaje.
                if (stary) { wynik.niedostepne.push(id); nowa.poz[id] = stary; }
                continue;
            }
            var wpis = { t: teraz };
            for (var j = 0; j < POLA.length; j++) wpis[POLA[j][0]] = biezacy[POLA[j][0]] === undefined ? null : biezacy[POLA[j][0]];
            nowa.poz[id] = wpis;
            if (!stary) { wynik.nowe.push(id); continue; }
            var r = roznice(stary, wpis);
            if (r.length) wynik.zmiany.push({ id: id, roznice: r }); else wynik.bezZmian.push(id);
        }
        // Wpisy zdrapek spoza listy obserwowanych znikaja (usuniecie z obserwowanych = usuniecie migawki).
        return { migawka: nowa, wynik: wynik };
    }

    function formatujLiczbe(n, en) {
        var s = String(n), out = '';
        while (s.length > 3) { out = (en ? ',' : '\u00a0') + s.slice(-3) + out; s = s.slice(0, -3); }
        return s + out;
    }
    function formatujDate(iso, en) {
        var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
        if (!m) return iso || '';
        return en ? m[3] + '/' + m[2] + '/' + m[1] : m[3] + '.' + m[2] + '.' + m[1];
    }
    /* Czytelna wartosc pola: null -> teksty.brak; kwoty z waluta; status po etykiecie. */
    function opiszWartosc(pole, v, teksty, en) {
        if (v === null || v === undefined) return teksty.brak;
        if (pole === 's') return teksty['status_' + v] || v;
        if (pole === 'k') return formatujDate(v, en);
        if (pole === 'g') return formatujLiczbe(v, en);
        return formatujLiczbe(v, en) + ' ' + teksty.waluta;
    }
    /* Jedna linia zmiany: „Etykieta: przed → po". */
    function opiszRoznice(r, teksty, en) {
        return teksty['pole_' + r.pole] + ': ' + opiszWartosc(r.pole, r.przed, teksty, en) + ' → ' + opiszWartosc(r.pole, r.po, teksty, en);
    }
    function podstaw(wzor, mapa) {
        return String(wzor).replace(/\{(\w+)\}/g, function (c, k) { return maWlasne(mapa, k) ? String(mapa[k]) : c; });
    }

    var API = {
        KLUCZ_MIGAWKI: KLUCZ_MIGAWKI, WERSJA: WERSJA, POLA: POLA.map(function (p) { return p.slice(); }), STATUSY: STATUSY.slice(),
        normalizujPole: normalizujPole, odczytajKafel: odczytajKafel, wczytajMigawke: wczytajMigawke,
        roznice: roznice, porownaj: porownaj, opiszRoznice: opiszRoznice, opiszWartosc: opiszWartosc,
        formatujLiczbe: formatujLiczbe, formatujDate: formatujDate, podstaw: podstaw
    };
    if (typeof module !== 'undefined' && module && module.exports) module.exports = API;
    if (root && typeof root === 'object' && root.document) root.PEWNIAKI_ZDRAPKI_ZMIANY = API;

    /* ------------------------------------------------------------------ */
    /* Czesc DOM                                                          */
    /* ------------------------------------------------------------------ */
    if (!root || typeof root.document === 'undefined' || !root.document) return;
    var document = root.document;

    function start() {
        var siatka = document.getElementById('zdrapki-kafle');
        var blok = document.querySelector('[data-zmiany-blok]');
        var stan = root.PEWNIAKI_ZDRAPKI_STAN;
        if (!siatka || !blok || !stan || typeof stan.wczytajListe !== 'function') return;
        var lista = blok.querySelector('[data-zmiany-lista]');
        var info = blok.querySelector('[data-zmiany-info]');
        var nota = blok.querySelector('[data-zmiany-nota]');
        if (!lista || !info) return;
        var en = /^en(?:-|$)/i.test(document.documentElement.lang || '');

        var teksty = null;
        (function () {
            var el = document.getElementById('zdrapki-zmiany-teksty');
            if (!el) return;
            var d;
            try { d = JSON.parse(el.textContent || ''); } catch (e) { return; }
            if (!d || typeof d !== 'object') return;
            for (var i = 0; i < KLUCZE_TEKSTOW.length; i++) if (typeof d[KLUCZE_TEKSTOW[i]] !== 'string') return;
            teksty = d;
        })();
        if (!teksty) return;

        function magazyn() { try { return root.localStorage || null; } catch (e) { return null; } }
        function czytaj(k) { try { var m = magazyn(); return m ? m.getItem(k) : null; } catch (e) { return null; } }
        function zapisz(k, v) { try { var m = magazyn(); if (!m) return false; m.setItem(k, v); return m.getItem(k) === v; } catch (e) { return false; } }

        function katalogKafli() {
            var out = {}, els = siatka.querySelectorAll('[data-zdrapka]');
            for (var i = 0; i < els.length; i++) {
                var id = normalizujId(els[i].getAttribute('data-zdrapka'));
                if (id !== null && !maWlasne(out, id)) out[id] = odczytajKafel(els[i]);
            }
            return out;
        }
        function tytul(id) {
            var el = siatka.querySelector('[data-zdrapka="' + id + '"]');
            return el ? (el.getAttribute('data-tytul') || id) : id;
        }
        function czysc(el) { while (el.firstChild) el.removeChild(el.firstChild); }
        function li(tekst) { var e = document.createElement('li'); e.textContent = tekst; return e; }
        function dataCzasu(ms) {
            var d = new Date(ms), p = function (n) { return (n < 10 ? '0' : '') + n; };
            return en ? p(d.getDate()) + '/' + p(d.getMonth() + 1) + '/' + d.getFullYear() + ', ' + p(d.getHours()) + ':' + p(d.getMinutes())
                : p(d.getDate()) + '.' + p(d.getMonth() + 1) + '.' + d.getFullYear() + ', ' + p(d.getHours()) + ':' + p(d.getMinutes());
        }

        /* Wynik z wczytania strony: klikniecia „Obserwuj" tylko go zawezaja (usuniecie)
           albo dopisuja baze (dodanie) — nie przeliczaja zmian od nowa, bo migawka
           jest juz nadpisana biezacym stanem i przeliczenie skasowaloby liste. */
        var pokazane = null, obserwowaneNaStarcie = [];

        function render(r, obserwowane) {
            czysc(lista);
            var i;
            for (i = 0; i < r.zmiany.length; i++) {
                var z = r.zmiany[i], e = document.createElement('li');
                var b = document.createElement('strong'); b.textContent = tytul(z.id);
                e.appendChild(b);
                var ul = document.createElement('ul');
                for (var j = 0; j < z.roznice.length; j++) ul.appendChild(li(opiszRoznice(z.roznice[j], teksty, en)));
                e.appendChild(ul);
                e.setAttribute('data-zmiana', z.id);
                lista.appendChild(e);
            }
            for (i = 0; i < r.niedostepne.length; i++) {
                var n = li(podstaw(teksty.niedostepna, { nazwa: tytul(r.niedostepne[i]) || r.niedostepne[i] }));
                n.setAttribute('data-niedostepna', r.niedostepne[i]);
                lista.appendChild(n);
            }
            if (!obserwowane.length) { blok.hidden = true; info.textContent = ''; return; }
            if (r.zmiany.length || r.niedostepne.length) {
                info.textContent = r.nowe.length ? podstaw(teksty.baza, { n: r.nowe.length }) : '';
                blok.setAttribute('data-zmiany-stan', 'zmiany');
            } else if (r.nowe.length && !r.bezZmian.length) {
                info.textContent = podstaw(teksty.baza, { n: r.nowe.length });
                blok.setAttribute('data-zmiany-stan', 'baza');
            } else {
                info.textContent = podstaw(teksty.bez_zmian, { data: r.poprzedniOdczyt ? dataCzasu(r.poprzedniOdczyt) : '' })
                    + (r.nowe.length ? ' ' + podstaw(teksty.baza, { n: r.nowe.length }) : '');
                blok.setAttribute('data-zmiany-stan', 'bez_zmian');
            }
            if (nota) nota.hidden = !(r.zmiany.length);
            blok.hidden = false;
        }

        /* Wczytanie strony: obserwowane -> porownanie z migawka -> zapis migawki -> render. */
        function odswiez() {
            if (!magazyn()) { blok.hidden = true; return; }
            var obserwowane = stan.wczytajListe(czytaj(stan.KLUCZ_MAGAZYNU));
            obserwowaneNaStarcie = obserwowane.slice();
            if (!obserwowane.length) {
                // Bez obserwowanych nie ma czego porownywac ani zapisywac.
                try { var m = magazyn(); if (m && m.getItem(KLUCZ_MIGAWKI) !== null) m.removeItem(KLUCZ_MIGAWKI); } catch (e) { /* nic */ }
                pokazane = null; blok.hidden = true; info.textContent = ''; czysc(lista);
                return;
            }
            var w = porownaj(obserwowane, katalogKafli(), wczytajMigawke(czytaj(KLUCZ_MIGAWKI)), Date.now());
            if (!zapisz(KLUCZ_MIGAWKI, JSON.stringify(w.migawka))) { pokazane = null; blok.hidden = true; info.textContent = ''; czysc(lista); return; }
            pokazane = w.wynik;
            render(pokazane, obserwowane);
        }

        /* Po kliknieciu „Obserwuj": migawka podaza za lista (dodana = wpis bazowy,
           usunieta = wpis znika), a widok tylko zaweza to, co juz pokazano. */
        function poZmianieListy() {
            if (!magazyn()) return;
            var obserwowane = stan.wczytajListe(czytaj(stan.KLUCZ_MAGAZYNU));
            if (!obserwowane.length) { odswiez(); return; }
            var w = porownaj(obserwowane, katalogKafli(), wczytajMigawke(czytaj(KLUCZ_MIGAWKI)), Date.now());
            if (!zapisz(KLUCZ_MIGAWKI, JSON.stringify(w.migawka))) { pokazane = null; blok.hidden = true; return; }
            var jest = function (id) { return obserwowane.indexOf(id) >= 0; };
            var nowe = [];
            for (var i = 0; i < obserwowane.length; i++) if (obserwowaneNaStarcie.indexOf(obserwowane[i]) < 0 && maWlasne(w.migawka.poz, obserwowane[i])) nowe.push(obserwowane[i]);
            var p = pokazane || { zmiany: [], bezZmian: [], niedostepne: [], nowe: [], poprzedniOdczyt: null };
            var r = { zmiany: p.zmiany.filter(function (z) { return jest(z.id); }), niedostepne: p.niedostepne.filter(jest),
                bezZmian: p.bezZmian.filter(jest), nowe: p.nowe.filter(jest).concat(nowe.filter(function (id) { return p.nowe.indexOf(id) < 0; })), poprzedniOdczyt: p.poprzedniOdczyt };
            render(r, obserwowane);
        }

        odswiez();
        // Zmiana listy obserwowanych (przycisk „Obserwuj" w kaflu obsluguje zdrapki-narzedzia.js
        // na siatce; tu, nizej w bablowaniu, tylko synchronizujemy migawke i widok).
        siatka.addEventListener('click', function (e) {
            var t = e.target;
            while (t && t !== siatka && !(t.getAttribute && t.getAttribute('data-akcja') === 'obserwuj')) t = t.parentNode;
            if (t && t !== siatka) root.setTimeout(poZmianieListy, 0);
        });
        root.addEventListener('storage', function (e) { if (e && (e.key === stan.KLUCZ_MAGAZYNU || e.key === KLUCZ_MIGAWKI)) odswiez(); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})(typeof window !== 'undefined' ? window : null);
